import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 26, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ index, label, title, sub, dark = false, as: Tag = "h2" }) {
  return (
    <Reveal className="max-w-3xl">
      <p className={`font-mono text-[11px] uppercase tracking-[0.24em] font-semibold ${dark ? "text-amber-400" : "text-amber-600"}`} data-testid="section-eyebrow">
        {index} — {label}
      </p>
      <Tag className={`mt-4 font-display font-extrabold tracking-tight leading-tight text-2xl sm:text-3xl lg:text-4xl ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </Tag>
      {sub && <p className={`mt-4 text-base leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>{sub}</p>}
    </Reveal>
  );
}

export default Reveal;
